"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _withIconProps = require("../utils/withIconProps");
var _react2 = require("@emotion/react");
/**
 * This file generated by Stencil generateIcons scripts
 * DO NOT EDIT DIRECTLY
 */

const IconChevronDownExtraSmall = (0, _withIconProps.withIconProps)(props => {
  return (0, _react2.jsx)("svg", (0, _extends2.default)({
    width: "16px",
    height: "16px",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), (0, _react2.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70711 10.7071C8.31658 11.0976 7.68342 11.0976 7.29289 10.7071L3.29289 6.70711C2.90237 6.31658 2.90237 5.68342 3.29289 5.29289C3.68342 4.90237 4.31658 4.90237 4.70711 5.29289L8 8.58579L11.2929 5.29289C11.6834 4.90237 12.3166 4.90237 12.7071 5.29289C13.0976 5.68342 13.0976 6.31658 12.7071 6.70711L8.70711 10.7071Z",
    fill: "currentColor"
  }));
}, 'IconChevronDownExtraSmall');
IconChevronDownExtraSmall.displayName = 'IconChevronDownExtraSmall';
var _default = exports.default = IconChevronDownExtraSmall;